<template>
  <div class="queue-tabs-container">
    <div
      @click="onChangeTab(tab)"
      v-for="(options,tab) in tabs"
      :key="tab"
      :class="{
        'tab': true,
        'tab-active': currentTab == tab || isDesktop  
      }">
      <img :src="currentTab == tab || isDesktop ? `/icons/tabs/${tab}-active.svg` : `/icons/tabs/${tab}.svg`">
      {{ $t(`tabs.${tab}`) }}
      <span :style="{
        'color': options.important && counters[tab] ? '#e2223b' : '#A4A3A1'
      }">({{ counters[tab] || 0 }})</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    currentTab: {
      type: String,
      default: 'new',
    },
    tabs: {
        type: Object,
    },
    counters: {
        type: Object
    }
  },
  methods: {
    onChangeTab(tab) {
      this.$emit("tabChanged", tab);
    },
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 767;
    }
  }
};
</script>
<style scoped>
.queue-tabs-container {
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  height: 21vw;
  width: 100%;
  display: flex;
  justify-content: space-around;
  background-color: rgba(29, 29, 27, 0.9);
  backdrop-filter: blur(7px);
}
.tab {
  color: #908f8d;
  font-size: 3.5vw;
  line-height: normal;
  display: flex;
  width: 33.3%;
  flex-direction: column;
  align-items: center;
  margin-top: 2.5vw
}
.tab img {
  margin: 0 auto 1.2vw;
  height: 7vw;
  width: auto;
}
.tab-active {
  color: #ededed;
}

.tab span {
  line-height:1.8vh;
}
@media screen and (min-width: 765px) {
  .queue-tabs-container {
    height: 10vh
  }
  .tab svg {
    margin-bottom: 0.347vw;
  }
  .tab img {
    height: 3.3vh;
    width: auto;
    margin: 0 auto 0.5vh;
  }
  .tab {
    font-size: 2vh;
    margin-top: 1.3vh;
  }
  .tab svg path {
    fill: #ededed;
  }
  .tab span {
    font-size: 1.7vh;
    line-height: normal;
  }
}
</style>